import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,{attrs:{"small":_vm.$vuetify.breakpoint.mobile,"outlined":"","color":"var(--agora)","close":_vm.closable,"close-icon":_vm.closeIcon},on:{"click":_vm.clicked}},[_vm._v(_vm._s(_vm.tag.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }